
import React from 'react';
import { Button } from '@/components/ui/button';

interface DialogActionsProps {
  onCancel: () => void;
  onSubmit: () => void;
  isDisabled: boolean;
}

const DialogActions: React.FC<DialogActionsProps> = ({ 
  onCancel, 
  onSubmit, 
  isDisabled 
}) => {
  return (
    <div className="flex justify-end space-x-2 pt-4">
      <Button variant="outline" onClick={onCancel}>
        Cancel
      </Button>
      <Button 
        onClick={onSubmit} 
        disabled={isDisabled}
      >
        Link to Card
      </Button>
    </div>
  );
};

export default DialogActions;
